import React, { memo, useCallback } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useRefCallback } from '@bydesign-ui/hooks';
export var ActiveTab;

(function (ActiveTab) {
  ActiveTab["DYNAMIC"] = "dynamic";
  ActiveTab["FIXED"] = "fixed";
})(ActiveTab || (ActiveTab = {}));

function DynamicDateHeaderItem(props) {
  var active = props.active,
      local = props.local;
  var cls = usePrefixCls('dynamic-date-header-item', {
    active: active
  });
  var textCls = usePrefixCls('dynamic-date-header-item-text');
  return React.createElement("div", {
    className: cls
  }, React.createElement("span", {
    className: textCls
  }, local));
}

var MemoDynamicDateHeaderItem = memo(DynamicDateHeaderItem);
export function DynamicDateHeader(props) {
  var onTabChange = props.onTabChange,
      active = props.active;
  var cls = usePrefixCls('dynamic-date-header');
  var headerLeft = usePrefixCls('dynamic-date-header-left', {
    active: active === ActiveTab.DYNAMIC
  });
  var headerRight = usePrefixCls('dynamic-date-header-right', {
    active: active === ActiveTab.FIXED
  });
  var onTabChangeCallback = useRefCallback(onTabChange);
  var dynamicDateLocale = useLocale('dynamic-date.dynamic-date');
  var fixedDateLocale = useLocale('dynamic-date.fixed-date');
  var handleLeftClick = useCallback(function () {
    if (active === ActiveTab.DYNAMIC) {
      return;
    }

    onTabChangeCallback(ActiveTab.DYNAMIC);
  }, [active]);
  var handleRightClick = useCallback(function () {
    if (active === ActiveTab.FIXED) {
      return;
    }

    onTabChangeCallback(ActiveTab.FIXED);
  }, [active]);
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: headerLeft,
    onClick: handleLeftClick
  }, React.createElement(MemoDynamicDateHeaderItem, {
    active: active === ActiveTab.DYNAMIC,
    local: dynamicDateLocale
  })), React.createElement("div", {
    className: headerRight,
    onClick: handleRightClick
  }, React.createElement(MemoDynamicDateHeaderItem, {
    active: active === ActiveTab.FIXED,
    local: fixedDateLocale
  })));
}
export default memo(DynamicDateHeader);